/* Relax Master - koopblok (Eenmalig / Routine / Bestel 3) voor de olie-PDP klonen (#rm-amandel).
   Zelf-injecterend, maar OLIE-ONLY: injecteert alleen op olie-PDP's (breadcrumb -> /collections/massage-olie-template).
   Doet niets als er geen #rm-amandel met .price-row (zonder bestaand koopblok) is,
   dus de amandel-pagina (.rm-pdp), homepage en collectiepagina's blijven ongemoeid.
   Leest de echte abonnementsprijs uit {product}.js (selling_plan_allocations). */
(function(){
  if(window.__rmOilKoop)return; window.__rmOilKoop=1;
  function boot(){
    var root=document.getElementById("rm-amandel");
    if(!root)return;
    /* OPT-IN olie-only: alleen productpagina's met een olie-breadcrumb (link naar de
       massage-olie collectie) krijgen het Eenmalig/Routine/Bestel-3 koopblok. Apparaat-
       en olieverwarmer-PDP's zijn van dezelfde #rm-amandel-template gekloond maar linken
       in hun breadcrumb naar olieverwarmers-los / massage-apparatuur -> geen match -> geen blok. */
    if(!root.querySelector('.crumbs a[href*="/collections/massage-olie-template"]'))return;
    if(root.querySelector(".purchase-opts"))return;
    var priceRow=root.querySelector(".price-row");
    var buy=root.querySelector(".buy");
    if(!priceRow||!buy)return;

    var variantId=root.dataset.variantId;
    var cartAddUrl=root.dataset.cartAddUrl||"/cart/add.js";
    var cartUrl=root.dataset.cartUrl||"/cart";
    var unit=parseInt(root.dataset.unit||"0",10)||0;
    var unitLabel=(root.querySelector(".size-badge")&&root.querySelector(".size-badge").textContent.trim())||"250 ml";
    /* Spiegel van de automatische korting "3+ flessen massageolie = 15% korting"
       (Shopify admin > Kortingen). Zelfde afronding als Shopify: korting per cent
       naar beneden. Wijzigt de korting in de admin, pas dan ook 0.15 hier aan. */
    var bundle3Cents=unit*3-Math.floor(unit*3*0.15);

    function fmt(c){var e=Math.floor(c/100),r=c%100;return ""+e+","+(r<10?"0"+r:r);}
    function esc(s){return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];});}

    if(!document.getElementById("rm-koop-style")){
      var st=document.createElement("style");st.id="rm-koop-style";
      st.textContent=
        '#rm-amandel .purchase-opts{display:flex;flex-direction:column;gap:10px;margin-bottom:24px}'+
        '#rm-amandel .popt{display:flex;align-items:center;gap:14px;width:100%;text-align:left;cursor:pointer;background:#fff;border:1.5px solid rgba(36,58,45,.14);border-radius:14px;padding:15px 18px;font-family:"Montserrat",system-ui,sans-serif;transition:border-color .18s,background .18s,box-shadow .18s}'+
        '#rm-amandel .popt:hover{border-color:#a9823c}'+
        '#rm-amandel .popt.selected{border-color:#a9823c;box-shadow:0 0 0 1px #a9823c;background:rgba(169,130,60,.06)}'+
        '#rm-amandel .popt-radio{flex:none;width:20px;height:20px;border-radius:50%;border:2px solid rgba(36,58,45,.14);position:relative;transition:border-color .18s}'+
        '#rm-amandel .popt.selected .popt-radio{border-color:#a9823c}'+
        '#rm-amandel .popt.selected .popt-radio::after{content:"";position:absolute;inset:3px;border-radius:50%;background:#a9823c}'+
        '#rm-amandel .popt-main{flex:1;display:flex;flex-direction:column;gap:3px;min-width:0}'+
        '#rm-amandel .popt-title{font-weight:700;color:#2d4947;font-size:1.1rem;display:flex;align-items:center;gap:9px;flex-wrap:wrap}'+
        '#rm-amandel .popt-sub{font-size:1.02rem;color:#42605c}'+
        '#rm-amandel .popt-price{font-family:"QuicheSans",Georgia,serif;font-weight:500;font-size:1.3rem;color:#2d4947;white-space:nowrap;text-align:right}'+
        '#rm-amandel .popt-badge{font-family:"Montserrat";font-size:.66rem;font-weight:700;letter-spacing:.05em;text-transform:uppercase;background:rgba(79,158,94,.14);color:#2f7d4a;padding:3px 8px;border-radius:999px}'+
        '#rm-amandel .popt-save{display:inline-block;background:#a97e35;color:#fff;font-size:10.5px;font-weight:700;letter-spacing:.04em;padding:2px 7px;border-radius:6px;vertical-align:middle}'+
        '#rm-amandel .popt-was{display:block;font-size:.78em;font-weight:400;color:#b6b0a4;text-decoration:line-through;margin-top:2px}'+
        '#rm-amandel .popt-routine{display:block !important}'+
        '#rm-amandel .popt-routine .popt-row{display:flex;align-items:center;gap:14px;width:100%}'+
        '#rm-amandel .popt-routine .popt-main{flex:1;min-width:0;text-align:left}'+
        '#rm-amandel .routine-freq{margin-top:14px;position:relative}'+
        '#rm-amandel .rf-toggle{width:100%;display:flex;align-items:center;justify-content:space-between;gap:10px;font-family:inherit;font-weight:600;color:#2d4947;background:#fff;border:1px solid #ddd6c6;border-radius:12px;padding:13px 16px;cursor:pointer}'+
        '#rm-amandel .rf-chev{width:16px;height:16px;flex:none;color:#a97e35;transition:transform .2s ease}'+
        '#rm-amandel .rf-toggle[aria-expanded="true"] .rf-chev{transform:rotate(180deg)}'+
        '#rm-amandel .rf-menu{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:40;background:#fff;border:1px solid #ece7dd;border-radius:12px;box-shadow:0 18px 44px -18px rgba(45,73,71,.45);padding:6px}'+
        '#rm-amandel .rf-opt{display:flex;align-items:center;justify-content:space-between;width:100%;text-align:left;font-family:inherit;font-weight:500;color:#2d4947;background:none;border:none;border-radius:8px;padding:12px;cursor:pointer}'+
        '#rm-amandel .rf-opt:hover{background:#f6f1e8}'+
        '#rm-amandel .rf-opt[aria-selected="true"]{color:#a97e35;font-weight:600}'+
        '#rm-amandel .buy.qty-hidden .stepper{display:none}';
      document.head.appendChild(st);
    }

    var opts=document.createElement("div");
    opts.className="purchase-opts";opts.id="rmokOpts";opts.setAttribute("role","radiogroup");opts.setAttribute("aria-label","Aankoopoptie");
    opts.innerHTML=
      '<button class="popt selected" type="button" data-mode="once" role="radio" aria-checked="true">'+
        '<span class="popt-radio"></span>'+
        '<span class="popt-main"><span class="popt-title">Eenmalig kopen</span><span class="popt-sub">'+esc(unitLabel)+', geen verplichtingen</span></span>'+
        '<span class="popt-price">'+fmt(unit)+'</span>'+
      '</button>'+
      '<button class="popt" type="button" data-mode="bundle3" role="radio" aria-checked="false">'+
        '<span class="popt-radio"></span>'+
        '<span class="popt-main"><span class="popt-title">Bestel 3 stuks <span class="popt-save">-15%</span> <span class="popt-badge">Gratis verzending</span></span><span class="popt-sub">Altijd voorraad in huis, nooit meer zonder olie</span></span>'+
        '<span class="popt-price">'+fmt(bundle3Cents)+'<span class="popt-was">'+fmt(unit*3)+'</span></span>'+
      '</button>';
    priceRow.insertAdjacentElement("afterend",opts);

    var qtyEl=document.getElementById("qty");
    var ctaPrice=document.getElementById("ctaPrice");
    var sCtaPrice=document.getElementById("sCtaPrice");
    var stickyQty=root.querySelector(".sticky-qty");
    var mode="once",routinePlanId=null,routineCents=0,planCents={};

    function getQty(){if(!qtyEl)return 1;var v=parseInt(qtyEl.value,10);if(isNaN(v)||v<1)v=1;return v;}
    function setPrice(c){var t=fmt(c);if(ctaPrice)ctaPrice.textContent=t;if(sCtaPrice)sCtaPrice.textContent=t;}
    function renderPrice(){
      if(mode==="routine")setPrice(routineCents);
      else if(mode==="bundle3")setPrice(bundle3Cents);
      else setPrice(unit*getQty());
      var hideQty=(mode!=="once");
      buy.classList.toggle("qty-hidden",hideQty);
      if(stickyQty)stickyQty.style.display=hideQty?"none":"";
      var rf=document.getElementById("routineFreq");
      if(rf)rf.hidden=(mode!=="routine");
    }
    function selectMode(btn){
      opts.querySelectorAll(".popt").forEach(function(x){x.classList.remove("selected");x.setAttribute("aria-checked","false");});
      btn.classList.add("selected");btn.setAttribute("aria-checked","true");
      mode=btn.getAttribute("data-mode");
      /* Het bundelaantal mag niet blijven hangen: alleen bundle3 zet 3,
         elke andere keuze (ook terug naar eenmalig) begint weer op 1. */
      if(mode==="bundle3"){if(qtyEl)qtyEl.value=3;}
      else {if(qtyEl)qtyEl.value=1;}
      renderPrice();
    }
    function bind(btn){
      btn.addEventListener("click",function(e){
        if(e.target.closest(".routine-freq"))return;
        selectMode(btn);
      });
    }
    opts.querySelectorAll(".popt").forEach(bind);
    if(qtyEl)qtyEl.addEventListener("input",function(){if(mode==="once")renderPrice();});

    /* Toont de ECHTE Seal-prijs per gekozen frequentie (selling_plan_allocations),
       niet langer een gerekende -15%. Badge en doorgestreepte prijs rekenen mee. */
    function injectRoutine(plans){
      if(!plans.length)return;
      var onceBtn=opts.querySelector('.popt[data-mode="once"]');
      if(!onceBtn)return;
      routinePlanId=plans[0].id;
      plans.forEach(function(p){planCents[p.id]=p.cents;});
      routineCents=planCents[routinePlanId]||unit;
      function badgeHtml(c){var saving=unit-c;var pct=unit>0&&saving>0?Math.round(saving*100/unit):0;return pct>0?' <span class="popt-save">-'+pct+'%</span>':'';}
      var menu="";
      plans.forEach(function(p,i){menu+='<button type="button" class="rf-opt" role="option" data-id="'+p.id+'" aria-selected="'+(i===0?"true":"false")+'">'+esc(p.name)+'</button>';});
      var div=document.createElement("div");
      div.className="popt popt-routine";div.setAttribute("role","radio");div.setAttribute("aria-checked","false");div.setAttribute("data-mode","routine");
      div.innerHTML=
        '<div class="popt-row"><span class="popt-radio"></span>'+
        '<span class="popt-main"><span class="popt-title">Routine<span id="rmokSave">'+badgeHtml(routineCents)+'</span></span>'+
        '<span class="popt-sub">Pauzeren of annuleren wanneer je wilt</span></span>'+
        '<span class="popt-price"><span id="rmokPrice">'+fmt(routineCents)+'</span><span class="popt-was">'+fmt(unit)+'</span></span></div>'+
        (plans.length>1?
        '<div class="routine-freq" id="routineFreq" hidden><button type="button" class="rf-toggle" id="rfToggle" aria-haspopup="listbox" aria-expanded="false"><span id="rfLabel">'+esc(plans[0].name)+'</span><svg class="rf-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg></button><div class="rf-menu" id="rfMenu" role="listbox" hidden>'+menu+'</div></div>'
        :'');
      onceBtn.insertAdjacentElement("afterend",div);
      bind(div);
      var rfToggle=document.getElementById("rfToggle"),rfMenu=document.getElementById("rfMenu"),rfLabel=document.getElementById("rfLabel");
      if(rfToggle&&rfMenu){
        rfToggle.addEventListener("click",function(e){e.stopPropagation();var willOpen=rfMenu.hidden;rfMenu.hidden=!willOpen;rfToggle.setAttribute("aria-expanded",willOpen?"true":"false");});
        rfMenu.querySelectorAll(".rf-opt").forEach(function(o){
          o.addEventListener("click",function(e){
            e.stopPropagation();
            routinePlanId=o.getAttribute("data-id");
            routineCents=planCents[routinePlanId]||unit;
            var priceEl=document.getElementById("rmokPrice");if(priceEl)priceEl.textContent=fmt(routineCents);
            var saveEl=document.getElementById("rmokSave");if(saveEl)saveEl.innerHTML=badgeHtml(routineCents);
            if(rfLabel)rfLabel.textContent=o.textContent;
            rfMenu.querySelectorAll(".rf-opt").forEach(function(x){x.setAttribute("aria-selected","false");});
            o.setAttribute("aria-selected","true");rfMenu.hidden=true;rfToggle.setAttribute("aria-expanded","false");
            if(mode==="routine")renderPrice();
          });
        });
        document.addEventListener("click",function(){if(!rfMenu.hidden){rfMenu.hidden=true;rfToggle.setAttribute("aria-expanded","false");}});
      }
    }

    document.addEventListener("click",function(e){
      var btn=e.target.closest?e.target.closest("#cta,#sCta"):null;
      if(!btn||!root.contains(btn))return;
      /* rm-pdp-notify.js (site-breed, capture) verzorgt de toevoeging al en is
         mode-bewust (eenmalig/bundel/routine incl. selling plan). Zonder deze
         guard voegen beide handlers toe en krijgt de klant 2x3 flessen. */
      if(window.__rmPdpNotify)return;
      if(mode==="once")return;
      e.preventDefault();e.stopImmediatePropagation();
      if(btn.dataset.busy)return;btn.dataset.busy="1";
      var old=btn.innerHTML;btn.innerHTML="Bezig...";
      var item=(mode==="routine"&&routinePlanId)?{id:Number(variantId),quantity:1,selling_plan:Number(routinePlanId)}:{id:Number(variantId),quantity:3};
      fetch(cartAddUrl,{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items:[item]})})
        .then(function(r){if(!r.ok)throw r;return r.json();})
        .then(function(){btn.innerHTML="Toegevoegd";window.location.href=cartUrl;})
        .catch(function(){btn.innerHTML=old;delete btn.dataset.busy;alert("Toevoegen aan winkelmand is niet gelukt. Probeer het opnieuw.");});
    },true);

    renderPrice();

    fetch(location.pathname.replace(/\/$/,"")+".js",{headers:{Accept:"application/json"}})
      .then(function(r){return r.ok?r.json():null;})
      .then(function(d){
        if(!d)return;
        var vid=Number(variantId);
        var variant=(d.variants||[]).filter(function(v){return v.id===vid;})[0]||(d.variants||[])[0];
        var allocs=(variant&&variant.selling_plan_allocations)||[];
        if(!allocs.length)return;
        var names={};
        (d.selling_plan_groups||[]).forEach(function(g){(g.selling_plans||[]).forEach(function(p){names[p.id]=(p.name||"").trim();});});
        var plans=allocs.map(function(a){return {id:a.selling_plan_id,name:names[a.selling_plan_id]||"Elke levering",cents:a.price};});
        injectRoutine(plans);
      }).catch(function(){});
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);
  else boot();
})();
